function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"]').forEach((details) => {
  const summary = details.querySelector('summary');
  if (summary) {
    summary.setAttribute('role', 'button');
    summary.setAttribute('aria-expanded', details.hasAttribute('open'));

    if (summary.nextElementSibling.getAttribute('id')) {
      summary.setAttribute('aria-controls', summary.nextElementSibling.id);
    }

    if (!summary.closest('header-drawer, menu-drawer')) {
      summary.parentElement.addEventListener('keyup', onKeyUpEscape);
    }
  }

  // Add 'toggle' event listener to handle accordion behavior
  details.addEventListener('toggle', (event) => {
    if (details.open) {
      // Close all other details elements
      document.querySelectorAll('[id^="Details-"]').forEach((otherDetails) => {
        if (otherDetails !== details) {
          otherDetails.removeAttribute('open');
          // Update aria-expanded attribute
          const otherSummary = otherDetails.querySelector('summary');
          if (otherSummary) {
            otherSummary.setAttribute('aria-expanded', 'false');
          }
        }
      });
    }
    // Update aria-expanded for the current summary
    if (summary) {
      summary.setAttribute('aria-expanded', details.open);
    }
  });
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });
    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    if (event.target.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && event.target.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');


    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
   
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');
    
    // Check if the slider should scroll vertically
    this.isVertical = this.hasAttribute('data-vertical');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;

    if (this.isVertical) {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetTop - this.sliderItemsToShow[0].offsetTop;
      this.slidesPerPage = Math.floor(
        (this.slider.clientHeight - this.sliderItemsToShow[0].offsetTop) / this.sliderItemOffset
      );
    } else {
      this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
      this.slidesPerPage = Math.floor(
        (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
      );
    }

    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    if (this.isVertical) {
      this.currentPage = Math.round(this.slider.scrollTop / this.sliderItemOffset) + 1;
    } else {
      this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;
    }

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage !== previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isVertical) {
      if (this.isSlideVisible(this.sliderItemsToShow[0], true) && this.slider.scrollTop === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1], true)) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    } else {
      if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
        this.prevButton.setAttribute('disabled', 'disabled');
      } else {
        this.prevButton.removeAttribute('disabled');
      }

      if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
        this.nextButton.setAttribute('disabled', 'disabled');
      } else {
        this.nextButton.removeAttribute('disabled');
      }
    }
  }

  isSlideVisible(element, vertical = false, offset = 0) {
    if (vertical) {
      const lastVisibleSlide = this.slider.clientHeight + this.slider.scrollTop - offset;
      return element.offsetTop + element.clientHeight <= lastVisibleSlide && element.offsetTop >= this.slider.scrollTop;
    } else {
      const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
      return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
    }
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    if (this.isVertical) {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollTop + step * this.sliderItemOffset
          : this.slider.scrollTop - step * this.sliderItemOffset;
    } else {
      this.slideScrollPosition =
        event.currentTarget.name === 'next'
          ? this.slider.scrollLeft + step * this.sliderItemOffset
          : this.slider.scrollLeft - step * this.sliderItemOffset;
    }
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    if (this.isVertical) {
      this.slider.scrollTo({
        top: position,
      });
    } else {
      this.slider.scrollTo({
        left: position,
      });
    }
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  get isJP() {
    const shopUrl = (typeof window !== 'undefined' && window.shopUrl) ? window.shopUrl : location.hostname || '';
    return /cariuma\.jp/i.test(shopUrl);
  }

  connectedCallback() {
    
    if (!this.isJP) return;

    const ensureReadyAndSelectVisible = () => {
      const sizeOptionField = this.querySelector('fieldset[data-size-option]');
      if (!sizeOptionField) return false;

      const sizeOptionName = sizeOptionField.dataset.sizeOption || 'Size';
      const sizeInputs = this.querySelectorAll(`input[name="${sizeOptionName}"]`);
      if (!sizeInputs || sizeInputs.length === 0) return false;

      this.checkActiveSizeVariantVisibility();
      return true;
    };

    // Observe until the size radios are present, then act once
    const observer = new MutationObserver((_mutations, obs) => {
      if (ensureReadyAndSelectVisible()) obs.disconnect();
    });
    observer.observe(this, { childList: true, subtree: true });

    // Also try immediately (in case the radios are already in the DOM)
    if (ensureReadyAndSelectVisible()) observer.disconnect();
  }

  // JP-only helper (only used when this.isJP)
  checkActiveSizeVariantVisibility() {
    const sizeOptionName = this.querySelector('fieldset[data-size-option]')?.dataset.sizeOption || 'Size';
    const sizeInputs = Array.from(this.querySelectorAll(`input[name="${sizeOptionName}"]`));

    let checkedInput = sizeInputs.find(input => input.checked);
    if (checkedInput) {
      checkedInput.dispatchEvent(new Event('change', { bubbles: true }));
      const label = checkedInput.nextElementSibling;
      if (label && label.style.display === 'none') {
        checkedInput.checked = false;
        checkedInput = null;
      }
    }

    if (!checkedInput) {
      const firstAvailableInput = sizeInputs.find(input => {
        const label = input.nextElementSibling;
        return label && label.style.display !== 'none';
      });
      if (firstAvailableInput) {
        firstAvailableInput.checked = true;
        firstAvailableInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    // this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.storeUserSize();

    if (!this.currentVariant) {
      // Determine the correct form to mark as unavailable
      const requestedProductId = Number(this.dataset.productId);
      const formId = `product-form-${this.dataset.section}`;
      const oppositeGenderFormId = `opposite-gender-product-form-${this.dataset.section}`;
      const currentForm = document.getElementById(formId);
      const oppositeGenderForm = document.getElementById(oppositeGenderFormId);

      // Mark both forms as unavailable since we don't have a valid currentVariant
      if (currentForm) {
          this.setUnavailable(formId);
          this.toggleAddButton(true, '', true, formId);
      }
      if (oppositeGenderForm) {
          this.setUnavailable(oppositeGenderFormId);
          this.toggleAddButton(true, '', true, oppositeGenderFormId);
      }

      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    // Retrieve the option names from the fieldset data attributes
    const genderOptionName = this.querySelector('fieldset[data-gender-option]')?.dataset.genderOption || 'Gender';
    const sizeOptionName = this.querySelector('fieldset[data-size-option]')?.dataset.sizeOption || 'Size';

    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });

    // Automatically set the gender based on the selected size
    const selectedSizeInput = this.querySelector(`input[name="${sizeOptionName}"]:checked`) ||
                     this?.querySelector('input[name="Size"]:checked');
    if (selectedSizeInput) {
        const productId = selectedSizeInput.dataset.productId;
        const genderInput = this.querySelector(`input[name="${genderOptionName}"][data-product-id="${productId}"]`);
        if (genderInput) {
            genderInput.checked = true;
            // Also update the options array to include the gender
            this.options[0] = genderInput.value; // Assuming Gender is the first option
        }
    }
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {

        // Check if the variant's options match the selected options
        const optionsMatch = variant.options.every((option, index) => {
            const match = this.options[index] === option;
            return match;
        });

        return optionsMatch;
    });

  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;
    // Retrieve the option names from the fieldset data attributes
    const genderOptionName = this.querySelector('fieldset[data-gender-option]')?.dataset.genderOption || 'Gender';
    const sizeOptionName = this.querySelector('fieldset[data-size-option]')?.dataset.sizeOption || 'Size';
    const isGiftCardProduct = this.hasAttribute('data-gift-card-product') ? true : false;
    const isMultigenderProduct = this.hasAttribute('data-multi-gender-product') ? true : false;
    const isUnisexProduct = this.hasAttribute('data-unisex-product') ? true : false;

    let is_size = false;
    if (name === sizeOptionName || name.toLowerCase() == 'size' ){
      is_size = true;
    }

    // update size label on variant change
    if (is_size || isGiftCardProduct) {
      const productContainer = document.querySelector('.js-main-product [data-active-gender]');
      const activeGender = productContainer.getAttribute('data-active-gender');
      const kidsSizeLabel = productContainer.getAttribute('data-kids-size-label');
      const productType = productContainer.getAttribute('data-product-type');
      const sizeLabel = target.closest('.variant-options__size').querySelector('.size-option_label');
    
      // Retrieve the currently selected location from the dropdown button
      const dropdownButton = document.getElementById('product-size-dropdown-button');
      const selectedLocation = dropdownButton?.dataset.selectedLocation || 'US'; // 'US' as a fallback if no location is found
    
      // Compute the correct size value:
      let sizeValue = target.value;
      if (productType === 'Footwear') {
        const baseAttr = activeGender === 'women' ? 'sizeWomen' : (activeGender === 'men' ? 'sizeMen' : null);
        if (baseAttr) {
          // Capitalize the first character of the location
          const locationKey = selectedLocation.charAt(0).toUpperCase() + selectedLocation.slice(1).toLowerCase();
          const attrWithLocation = baseAttr + locationKey;
    
          // Retrieve the size value from data attributes or fallback to target value
          sizeValue = target.dataset[attrWithLocation] || target.dataset[baseAttr] || target.value;
        }
      }
    
      // Determine the size label text based on product type and active gender
      let sizeLabelText;
      if (productType === 'Footwear') {
        if (activeGender === 'women') {
          sizeLabelText = window.genderStrings.women +` ${selectedLocation} ${sizeValue}`;
        } else if (activeGender === 'men') {
          sizeLabelText = window.genderStrings.men +` ${selectedLocation} ${sizeValue}`;
        } else {
          sizeLabelText = sizeValue;
        }
      } else if(productType === 'Kids Footwear') {
        sizeLabelText = `${kidsSizeLabel} ${target.dataset.defaultValue}`;
      } else {
        sizeLabelText = sizeValue;
      }

      // Update the size label text in the DOM
      sizeLabel.textContent = sizeLabelText;

      if (productType === 'Footwear') {
        // 1. Update `.product-property_other-country-size-scale` Inputs
        
        const sizeCountryCodeInputs = document.querySelectorAll('.product-property_other-country-size-scale');
        
        if (sizeCountryCodeInputs.length > 0) {
          sizeCountryCodeInputs.forEach((inputElement) => {
            inputElement.value = `${sizeOptionName} ${selectedLocation}`.trim();
          });
        } else {
          console.warn('Input(s) with selector .product-property_other-country-size-scale not found.');
        }

        // 2. Update `.product-property_other-country-size-value` Inputs

        // Access size values directly from the target's data attributes
        // e.g., data-size-men-br or data-size-women-br based on gender and location
        const sizeMenAttrHyphen = `size-men-${selectedLocation.toLowerCase()}`; // e.g., size-men-br
        const sizeWomenAttrHyphen = `size-women-${selectedLocation.toLowerCase()}`; // e.g., size-women-br

        const sizeMenAttr = toCamelCase(sizeMenAttrHyphen); // e.g., sizeMenBr
        const sizeWomenAttr = toCamelCase(sizeWomenAttrHyphen); // e.g., sizeWomenBr


        // Retrieve size values
        const sizeMenValue = target.dataset[sizeMenAttr] || '';
        const sizeWomenValue = target.dataset[sizeWomenAttr] || '';

        // Construct the formatted size string
        const formattedSizeString = `M ${sizeMenValue} / W ${sizeWomenValue}`.trim();

        // Select all `.product-property_other-country-size-value` inputs
        const otherCountrySizeInputs = document.querySelectorAll('.product-property_other-country-size-value');
        
        if (otherCountrySizeInputs.length > 0) {
          otherCountrySizeInputs.forEach((inputElement) => {
            inputElement.value = formattedSizeString;
          });
        } else {
          console.warn('Input(s) with selector .product-property_other-country-size-value not found.');
        }

      }

      /* Update size value in the sticky bar -- TODO Update to support scale sizes */
      if(sizeLabel) sizeLabel.textContent = sizeLabelText;

      // update mobile size dropdown active size label
      const mobileBarSize = document.querySelector('.js-main-product .mobile-sticky-bar-wrapper .mobile-active-size');
      const mobileBarSelect = document.querySelector('.js-main-product .mobile-sticky-bar-wrapper .mobile-sticky-select');
      if(mobileBarSize && typeof mobileBarSize !== 'undefined') {
        if(!isGiftCardProduct) mobileBarSize.textContent = sizeLabel.textContent;
        if(isGiftCardProduct) mobileBarSize.textContent = target.dataset.inputValue;

        if((activeGender === 'women' && !isGiftCardProduct && isMultigenderProduct) || (activeGender === 'women' && !isGiftCardProduct && isUnisexProduct)) {
          mobileBarSelect.value = target.dataset.sizeWomen;
        } else if((activeGender === 'men' && !isGiftCardProduct && isMultigenderProduct) || activeGender === 'men' && !isGiftCardProduct && isUnisexProduct) {
          mobileBarSelect.value = target.dataset.sizeMen;
        } else if(isGiftCardProduct) {
          mobileBarSelect.value = target.dataset.inputValue;
        } else if(!isMultigenderProduct) {
          mobileBarSelect.value = target.dataset.defaultValue;
        } else {
          mobileBarSelect.value = target.value;
        }
      }

    }
    //end update size label on variant change

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateURL() {
    // Identify the form for the opposite gender product.
    const oppositeGenderFormId = `opposite-gender-product-form-${this.dataset.section}`;
    const oppositeGenderForm = document.getElementById(oppositeGenderFormId);

    // If the opposite gender form (product) exists, skip showing variant details in the URL.
    if (oppositeGenderForm) return;
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    // Identify the form for the opposite gender product.
    const oppositeGenderFormId = `opposite-gender-product-form-${this.dataset.section}`;
    const oppositeGenderForm = document.getElementById(oppositeGenderFormId);

    // If the opposite gender form (product) exists, skip showing variant details in the URL.
    if (oppositeGenderForm) return;

    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const requestedProductId = this.currentVariant.product_id;
    const productIdFromDataset = Number(this.dataset.productId);

    // Identify the form based on the product ID
    const formId = (requestedProductId === productIdFromDataset) 
        ? `product-form-${this.dataset.section}` 
        : `opposite-gender-product-form-${this.dataset.section}`;
    
    const productForm = document.getElementById(formId);
    const productFormContainer = document.getElementById(formId + '__container');
    if (!productForm) return;

    // Hide the currently visible form and show the selected one
    const otherFormId = (requestedProductId === productIdFromDataset) 
        ? `opposite-gender-product-form-${this.dataset.section}` 
        : `product-form-${this.dataset.section}`;
    const otherFormContainer = document.getElementById(otherFormId + '__container');

    if (otherFormContainer) {
        otherFormContainer.style.display = 'none';
    }

    setTimeout(() => {
        productFormContainer.style.display = 'block';

        // start update mobile sticky button form id
        const mobileBarBtn = document.querySelector('.js-main-product .mobile-sticky-bar-wrapper button');
        if(mobileBarBtn && typeof mobileBarBtn !== 'undefined') mobileBarBtn.setAttribute('form', formId);
        // end update mobile sticky button form id
    }, 10); // Delay to ensure display change is applied after hiding the other form
    
    // Find the correct input field associated with the selected variant's product
    const input = productForm.querySelector('input[name="id"]');
    if (input) {
        input.value = this.currentVariant.id;
        input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  } 

  updateVariantStatuses() {
    // Check if there's a form on the page for the opposite gender product
    const oppositeGenderFormExists = document.querySelector('.product-form[id^="opposite-gender-product-form-"]');

    // Get all .product-form elements and pull their data-product-id values as an array
    const productFormIds = [...document.querySelectorAll('.product-form')].map(form => Number(form.dataset.productId));

    // Iterate over each productFormId to process the variants separately for each product form
    productFormIds.forEach(productId => {

      let selectedOptionOneVariants;

      if (oppositeGenderFormExists) {
        // Filter variants for the current product form
        selectedOptionOneVariants = this.variantData.filter((variant) => {
            if (variant.product_id === productId) {
              return variant.option1;
            }
        });
      } else {
        selectedOptionOneVariants = this.variantData.filter((variant) => {
          return this.querySelector(':checked').value === variant.option1;
        });
      }

        // Iterate over each option group within the form to update availability
        const inputWrappers = [...this.querySelectorAll('.product-form__input')];
        inputWrappers.forEach((option, index) => {
            if (index === 0) return;

            // Determine the value of the previous option selected
            let previousOptionSelected;
            if (oppositeGenderFormExists && index === 1) {
                // If opposite gender form exists, pull the value from the first variant in this.variantData for the current productId
                previousOptionSelected = this.variantData.find(variant => variant.product_id === productId).option1;
            } else {
                // Otherwise, use the value from the previous option group in the current form
                previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
            }

            // Get all radio inputs or option elements within this option group, filtered by the current productId
            const optionInputs = [...option.querySelectorAll(`input[type="radio"][data-product-id="${productId}"], option[data-product-id="${productId}"]`)];

            // Determine available options based on selected value and availability in the variant data
            const availableOptionInputsValue = selectedOptionOneVariants
                .filter((variant) => 
                    variant.available && variant[`option${index}`] === previousOptionSelected
                )
                .map((variantOption) => variantOption[`option${index + 1}`]);

            // Update the availability of the options in this group
            this.setInputAvailability(optionInputs, availableOptionInputsValue);
        });
    });
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
  
    // Check if product-form exists but might not be ready
    if (productForm) {
      // If handleErrorMessage exists, call it directly
      if (typeof productForm.handleErrorMessage === 'function') {
        productForm.handleErrorMessage();
      } else {
        // Otherwise, wait for the custom element to be fully defined
        // using requestAnimationFrame to wait for the next rendering cycle
        requestAnimationFrame(() => {
          if (typeof productForm.handleErrorMessage === 'function') {
            productForm.handleErrorMessage();
          }
        });
      }
    }
  }

  updateMedia(html) {
    const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
    const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
      const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
      const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
      const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
      let shouldRefresh = false;

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

        if (sourceData && sourceData.index !== destinationIndex) {
          mediaGallerySource.insertBefore(
            sourceData.item,
            mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
          );

          // refresh source now that it has been modified
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    }

    if (this.currentVariant.featured_media) {
      document
        .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
        ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
    }

    // update media modal
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newModalContent = html.querySelector(`product-modal`);
    if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
  }

  renderProductInfo() {
    const requestedProductId = this.currentVariant.product_id;
    const productIdFromDataset = Number(this.dataset.productId);
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    // Determine which product's data to fetch
    const isMainProduct = (requestedProductId === productIdFromDataset);
    
    // Use the appropriate URL for the main or opposite gender product
    const urlToFetch = isMainProduct 
        ? `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${sectionId}`
        : `${this.dataset.oppositeGenderUrl}?variant=${this.currentVariant.id}&section_id=${sectionId}`;

    // Identify the form based on the product ID
    const formId = isMainProduct 
        ? `product-form-${this.dataset.section}` 
        : `opposite-gender-product-form-${this.dataset.section}`;

    const requestedVariantId = this.currentVariant.id;

    fetch(urlToFetch)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');

        if (isMainProduct) {
          // Update product information for the main product only
          const destination = document.getElementById(`price-${this.dataset.section}`);
          const source = html.getElementById(
            `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          // update product mobile price
          const mobilePrice = document.querySelector('.product-price-mobile');
          if(mobilePrice) mobilePrice.innerHTML = source.querySelector('.price').outerHTML;
          const skuSource = html.getElementById(
            `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
          const inventorySource = html.getElementById(
            `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );
          const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

          const volumePricingSource = html.getElementById(
            `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );

          this.updateMedia(html);

          const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
          const pricePerItemSource = html.getElementById(
            `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
          );

          const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
          const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
          const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

          if (volumeNote) volumeNote.classList.remove('hidden');
          if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
          if (qtyRules) qtyRules.classList.remove('hidden');

          if (source && destination) destination.innerHTML = source.innerHTML;
          if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
          if (skuSource && skuDestination) {
            skuDestination.innerHTML = skuSource.innerHTML;
            skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
          }

          if (volumePricingSource && volumePricingDestination) {
            volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
          }

          if (pricePerItemSource && pricePerItemDestination) {
            pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
            pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
          }

          const price = document.getElementById(`price-${this.dataset.section}`);

          if (price) price.classList.remove('hidden');

          if (inventoryDestination) inventoryDestination.classList.toggle('hidden', inventorySource.innerText === '');
        }

        // start handle inventory/preorder msgs
        const productFormWrapper = Array.from(document.querySelectorAll('.product-form-wrapper')).filter(form => form.querySelector('.product-form').style.display !== 'none')[0];
        const isInventoryMsg = html.querySelector('.product-form-wrapper').dataset.hasInventoryMsg;
        const isPreorderMsg = Array.from(html.querySelectorAll('.product-form-wrapper')).filter(form => form.querySelector('.product-form').style.display !== 'none')[0].dataset.hasPreorderMsg;
        const docInventoryMsgs = document.querySelectorAll('.buy_buttons__wrapper .low-inventory-alerts-wrapper');
        const docPreorderMsg = productFormWrapper.querySelector('.preorder-inventory-msg-wrapper');

        if(isInventoryMsg === 'true') {
          const inventoryMsg = html.querySelector('.buy_buttons__wrapper .low-inventory-alerts-wrapper');
          
          if(docInventoryMsgs.length > 0) docInventoryMsgs.forEach(msg => msg.remove());
          document.querySelector('.buy_buttons__wrapper').insertBefore(inventoryMsg, document.querySelector('.product-form-wrapper'));
        } else {
          docInventoryMsgs?.forEach(msg => msg.remove());
        }

        if(isPreorderMsg === 'true') {
          const preorderMsg = html.querySelector('.buy_buttons__wrapper .preorder-inventory-msg-wrapper');
          if(docPreorderMsg) {
            docPreorderMsg.innerHTML = preorderMsg.innerHTML
          } else {
            productFormWrapper.querySelector('.product-form').insertBefore(preorderMsg, productFormWrapper.querySelector('.product-form .form'));
          }
        } else {
          docPreorderMsg?.remove();
        }

        // update active product form attributes
        productFormWrapper.dataset.hasInventoryMsg = `${isInventoryMsg}`;
        productFormWrapper.dataset.hasPreorderMsg = `${isPreorderMsg}`;

        // update active product form with selected variant form to update all form inputs
        productFormWrapper.querySelector('form').innerHTML = html.querySelector('.product-form-wrapper form').innerHTML;
        // end handle inventory/preorder msgs

        // Update the Add to Cart button for either the main or opposite gender product
        const constructedId = `ProductSubmitButton-${requestedProductId}-${sectionId}`;
        const addButtonUpdated = html.getElementById(constructedId);

        this.toggleAddButton(
            addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
            window.variantStrings.soldOut,
            true,
            formId
        );

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
    })
    .catch((error) => {
      console.error('Error fetching variant info:', error);
    });
  }

  toggleAddButton(disable = true, text, modifyClass = true, formId) {
    const requestedProductId = this.currentVariant?.product_id;
    const requestedVariantId = this.currentVariant?.id;
    const productIdFromDataset = Number(this.dataset.productId);
  
    if (!formId) {
      // Identify the form based on the product ID
      formId = (requestedProductId === productIdFromDataset) 
          ? `product-form-${this.dataset.section}` 
          : `opposite-gender-product-form-${this.dataset.section}`;
    }
  
    const productForm = document.getElementById(formId);
    if (!productForm) return;
  
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const BISModal = productForm.querySelector('bis-modal');
    const mobileBarBtn = document.querySelector('.js-main-product .mobile-sticky-bar-wrapper .mobile-sticky-form-btn');
    const mobileBarBisBtn = document.querySelector('.js-main-product .mobile-sticky-bar-wrapper .BIS_trigger');
    const productEstimatedDeliveryMsg = document.querySelector('.product .estimated-delivery-date-wrapper');
    
    // Get elements from junior developer's code
    const buyBtnWrapper = document.querySelector('.js-main-product .product-form-wrapper');
    const bisBtn = buyBtnWrapper?.querySelector('.bis-notify-btn');
    const bisTrigger = buyBtnWrapper?.querySelector('.bis-trigger-modal');
    
    const isPreorderMsg = Array.from(document.querySelectorAll('.product-form-wrapper'))
      .filter(form => form.querySelector('.product-form').style.display !== 'none')[0]?.dataset.hasPreorderMsg;
    
    if (!addButton) return;
  
    // update add to cart btns back to normal state
    addButton.classList.remove('checkout-url');
    mobileBarBtn?.classList.remove('mobile-checkout-url');
    addButton.closest('form').removeAttribute('data-btn-action-checkout');
  
    // hide estimated delivery msg on sold out/preorder items + update product form soldout data attribute
    if (productEstimatedDeliveryMsg && 
        (this.currentVariant.available === false || isPreorderMsg === 'true')) {
      productEstimatedDeliveryMsg?.classList.add('hidden');
      productForm.closest('[data-product-soldout]').dataset.productSoldout = 'soldout';
    } else if (productEstimatedDeliveryMsg) {
      productEstimatedDeliveryMsg?.classList.remove('hidden');
      productForm.closest('[data-product-soldout]').dataset.productSoldout = 'not-soldout';
      if (typeof estimatedDeliveryDate === 'function') estimatedDeliveryDate();
    }


    // Update active gender private property value after form update
    const genderPrivateProperties = document.querySelectorAll('.product-private-property_gender-value');
    if(genderPrivateProperties.length) {
      const genderContainer = document.querySelector('.gender-tabs__container');
      const activeGender = genderContainer?.querySelector('.active').dataset.tabGender ?? genderContainer?.querySelector('.active .gender-link')?.textContent.toLocaleLowerCase().trim() ?? 'women';
      genderPrivateProperties.forEach(input => {
        input.setAttribute('value', activeGender);
      })
    }
  
    // Integrated BIS functionality with polling mechanism
    const handleBISFunctionality = () => {
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        
        // Check if BIS app is available and variant is out of stock
        if (typeof window.BIS !== 'undefined' && this.currentVariant.available === false) {
          // Handle existing BIS modal
          addButton.classList.add('hidden');
          BISModal?.classList.remove('hidden');
          BISModal?.removeAttribute('disabled');
          BISModal?.setAttribute('data-variant-id', this.currentVariant.id);
          
          // Handle junior dev's BIS elements
          bisTrigger?.classList.remove('hidden');
          bisBtn?.removeAttribute('disabled');
          
          // Update mobile sticky add to cart button
          if (mobileBarBtn && typeof mobileBarBtn !== 'undefined') {
            mobileBarBtn.setAttribute('disabled', 'disabled');
            mobileBarBtn.classList.add('hidden');
            mobileBarBisBtn?.classList.remove('hidden');
            mobileBarBisBtn?.removeAttribute('disabled');
            mobileBarBisBtn?.setAttribute('data-variant-id', this.currentVariant.id);
          }
        }
        
        if (text) addButtonText.textContent = text;
      } else {
        // Product is available
        if (typeof window.BIS !== 'undefined') {
          addButton.classList.remove('hidden');
          BISModal?.classList.add('hidden');
          BISModal?.setAttribute('disabled', 'disabled');
          
          // Handle junior dev's BIS elements
          bisTrigger?.classList.add('hidden');
          
          // Update mobile sticky add to cart button
          if (mobileBarBtn && typeof mobileBarBtn !== 'undefined') {
            mobileBarBtn.classList.remove('hidden');
            mobileBarBtn.removeAttribute('disabled');
            mobileBarBisBtn?.classList.add('hidden');
          }
        }
        
        addButton.removeAttribute('disabled');
        addButtonText.innerHTML = window.variantStrings.addToCart;
      }
    };
  
    // Check if BIS is loaded, with polling mechanism
    if (disable && this.currentVariant && !this.currentVariant.available) {
      // Try to use BIS app if it's available
      if (typeof window.BIS !== 'undefined') {
        handleBISFunctionality();
      } else {
        // BIS app not loaded yet, try polling for it
        let maximumTry = 0;
        const interval = setInterval(() => {
          if (typeof window.BIS !== 'undefined') {
            clearInterval(interval);
            handleBISFunctionality();
          }
          maximumTry++;
          if (maximumTry === 5) clearInterval(interval);
        }, 250); // Faster polling than the original 500ms
      }
    } else {
      // Normal handling without polling
      handleBISFunctionality();
    }
  
    if (!modifyClass) return;
  }

  setUnavailable(formId) {

    const button = document.getElementById(formId);
    if (!button) return;
    
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;

    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    const variantDataElement = this.querySelector('[type="application/json"]');
    if (!variantDataElement) return [];
  
    const variantData = JSON.parse(variantDataElement.textContent);
  
    // Initialize variantData as an empty array if no valid data is found
    this.variantData = [];
  
    // Add primary product variants if they exist
    if (variantData.primaryProductVariants && Array.isArray(variantData.primaryProductVariants)) {
      this.variantData = [...variantData.primaryProductVariants];
    }
  
    // Add opposite gender product variants if they exist and are not null
    if (variantData.oppositeGenderProductVariants && Array.isArray(variantData.oppositeGenderProductVariants)) {
      this.variantData = [...this.variantData, ...variantData.oppositeGenderProductVariants];
    }
  
    return this.variantData;
  }

  storeUserSize() {
    // Get the size option name from the fieldset attribute.
    const sizeOptionName = this.querySelector('fieldset[data-size-option]')?.dataset.sizeOption || 'Size';
    // Find the currently checked size input.
    const selectedSizeInput = this.querySelector(`input[name="${sizeOptionName}"]:checked`) ||
                     this?.querySelector('input[name="Size"]:checked');;
    if (!selectedSizeInput) return;
  
    // Determine the active gender.
    const productContainer = document.querySelector('.js-main-product [data-active-gender]');
    const activeGender = productContainer ? productContainer.getAttribute('data-active-gender') : 'men';
  
    // Determine which data attribute to read based on active gender.
    const sizeAttr = activeGender.toLowerCase() === 'men' ? 'data-size-men' : 'data-size-women';
    const sizeValue = selectedSizeInput.getAttribute(sizeAttr);
  
    // Choose the cart attribute key based on gender.
    const cartAttributeKey = activeGender.toLowerCase() === 'men' ? 'user_men_size' : 'user_women_size';
  
    // Update the cart attribute via Shopify's AJAX API.
    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        attributes: {
          [cartAttributeKey]: sizeValue
        }
      })
    })
    .then(response => response.json())
    .then(data => {
      console.log(`Updated ${cartAttributeKey} to ${sizeValue}:`, data);
    })
    .catch(err => console.error('Error updating user size:', err));
  }
}

customElements.define('variant-selects', VariantSelects);

/**
 * Converts a hyphen-separated string to camelCase.
 * @param {string} str - The hyphen-separated string.
 * @returns {string} - The camelCase version of the string.
 */
function toCamelCase(str) {
  return str.replace(/-([a-z])/g, (match, p1) => p1.toUpperCase());
}


class GenderToggle extends HTMLElement {
  constructor() {
    super();
    this.tabs = this.querySelectorAll('[role="tab"]');
    this.menTab = this.querySelector('#men-tab');
    this.womenTab = this.querySelector('#women-tab');
    this.mainProductAttr = document.querySelector('.js-main-product [data-active-gender]');
    this.pageBreadcrumbs = document.querySelector('.breadcrumbs');
    this.pageBreadcrumbsGender = this.pageBreadcrumbs.querySelector('.breadcrumb_gender');
    this.pageBreadcrumbsCollection = this.pageBreadcrumbs.querySelector('.breadcrumb_collection');

    this.tabs.forEach((tab) => {
      tab.addEventListener('click', (event) => this.onTabClick(event));
    });
  }

  onTabClick(event) {
    // update data attributes
    this.mainProductAttr.setAttribute('data-active-gender', event.currentTarget.dataset.tabGender);
    // end update data attributes
    this.tabs.forEach((tab) => {
      const isSelected = tab === event.currentTarget;
      tab.setAttribute('aria-selected', isSelected);

      // Update the active class based on selection
      if (isSelected) {
        tab.classList.add('active');
      } else {
        tab.classList.remove('active');
      }
    });
    this.updateActiveGender(event.currentTarget.id);
    this.updateSizeOptions(event.currentTarget.id);

    // start code update breadcrumb method
    this.updatePageBreadcrumbs(event.currentTarget);
    // end code update breadcrumb method

    // call product cards style collection method
    this.updateProductStylesHandle(event.currentTarget);
  }

  // start code breadcrumb method
  async updatePageBreadcrumbs(elm) {
    let genderHref, collectionHref;
    const breadcrumbGender = elm.dataset.tabGender;
    const activeGender = elm.id === 'women-tab' ? 'women' : 'men';
    const materialTabs = document.querySelectorAll('.material-tabs__container li a');
    
    this.pageBreadcrumbsGender.textContent = breadcrumbGender;

    if(activeGender === 'women') {
      genderHref = this.pageBreadcrumbsGender.href.replace('men', 'women');
      collectionHref = this.pageBreadcrumbsCollection?.href.replace('-men', '-women');
      // update material tabs link gender
      materialTabs?.forEach(tab => {
        if(tab.href.includes('-men')) tab.href = tab.href.replace('-men', '-women');
      });
    } else if(activeGender === 'men') {
      genderHref = this.pageBreadcrumbsGender.href.replace('women', 'men');
      collectionHref = this.pageBreadcrumbsCollection?.href.replace('-women', '-men');
      // update material tabs link gender
      materialTabs?.forEach(tab => {
        if(tab.href.includes('-women')) tab.href = tab.href.replace('-women', '-men');
      });
    }

    this.pageBreadcrumbsGender.setAttribute('href', genderHref);
    this.pageBreadcrumbsCollection?.setAttribute('href', collectionHref);


    // Update size guide page
    let fetchPageURL = window.Shopify.routes.root;
    const sizePageOpener = document.querySelector('.size-page-opener');
    const sizePageModal = document.querySelector('.size-page-modal');
    let sizePageOpenerString = sizePageOpener.dataset.sizePageOpenerLabel;
    let sizePageModalString = sizePageModal.dataset.sizePageModalLabel;

    if(sizePageOpener && sizePageModal) {
      if(activeGender === 'women') {
        fetchPageURL = fetchPageURL + sizePageOpener.dataset.sizePageWomen;
        sizePageOpenerString = sizePageOpenerString + 'women';
        sizePageModalString = sizePageModalString + 'women';
      } else if(activeGender === 'men') {
        fetchPageURL = fetchPageURL + sizePageOpener.dataset.sizePageMen;
        sizePageOpenerString = sizePageOpenerString + 'men';
        sizePageModalString = sizePageModalString + 'men';
      } else if (activeGender === 'kids') {
        fetchPageURL = fetchPageURL + sizePageOpener.dataset.sizePageKids;
        sizePageOpenerString = sizePageOpenerString + 'kids';
        sizePageModalString = sizePageModalString + 'kids';
      } else if (activeGender === 'accessories') {
        fetchPageURL = fetchPageURL + sizePageOpener.dataset.sizePageAccessories;
        sizePageOpenerString = sizePageOpenerString + 'accessories';
        sizePageModalString = sizePageModalString + 'accessories';
      } else {
        // fallback page to women
        fetchPageURL = fetchPageURL + sizePageOpener.dataset.sizePageWomen;
        sizePageOpenerString = sizePageOpenerString + 'women';
        sizePageModalString = sizePageModalString + 'women';
      }

      // return if page url is not found
      if(!fetchPageURL.includes('.json')) {
        sizePageOpener.classList.add('hidden');
        sizePageModal.classList.add('hidden');
        return;
      }

      try{
        const {page} = await (await fetch(fetchPageURL)).json();

        if(page) {
          sizePageOpener.classList.remove('hidden');
          sizePageModal.classList.remove('hidden');
          sizePageOpener.querySelector('.button')?.setAttribute('aria-label', sizePageOpenerString);
          sizePageModal.querySelector('.size-page-modal_content').setAttribute('aria-label', sizePageModalString);
          sizePageModal.querySelector('.size-page-modal_content-title').textContent = page.title;
          sizePageModal.querySelector('.size-page-modal_content-inner-content').innerHTML = page.body_html;
        } else {
          sizePageOpener.classList.add('hidden');
          sizePageModal.classList.add('hidden');
        }
      } catch(error) {
        console.error('New page Request failed:', error);
      }
    }
  }
  // end code breadcrumb method

  // start code: update all product styles collection handle
  updateProductStylesHandle(elm) {
    const activeGender = elm.id === 'women-tab' ? '-women' : '-men';
    const productCardsStyle = document.querySelectorAll('.product-card-wrapper .card-product_style');
    const productTitleStyles = document.querySelectorAll('.product-title_style');
    const allProductStyles = [...productCardsStyle, ...productTitleStyles];
    allProductStyles?.forEach(style => {
      if(style.href && (style.href.includes('-women') || style.href.includes('-men'))) {
        if(activeGender === '-women') {
          const href = style.href.replace('-men', activeGender);
          style.setAttribute('href', href);
        } else {
          const href = style.href.replace('-women', activeGender);
          style.setAttribute('href', href);
        }
      }
    })
  }
  // end code: update all product styles collection handle

  updateActiveGender(selectedTabId) {
    const isWomenSelected = selectedTabId === 'women-tab';
    const activeGender = isWomenSelected ? 'women' : 'men';

    var attributesToUpdate = {
      'active_gender': activeGender
    };

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ attributes: attributesToUpdate })
    })
    .then(response => response.json())
    .then(data => {
      //console.log('Active Gender update Success:', data);
    })
    .catch((error) => {
      //console.error('Active Gender update Error:', error);
    });
  }

  updateSizeOptions(selectedTabId) {
    const isWomenSelected = selectedTabId === 'women-tab';
    const sizeOptionName = document.querySelector('fieldset[data-size-option]')?.dataset.sizeOption || 'Size';
    const list = document.querySelectorAll(`input[name="${CSS.escape(sizeOptionName)}"]`);
    const sizeInputs = list.length ? list : document.querySelectorAll('input[name="Size"]');
    
    let firstAvailableSizeInput = null;

    // Declare dropdownButton and selectedLocation once within the function
    const dropdownButton = document.getElementById('product-size-dropdown-button');
    const selectedLocation = dropdownButton?.dataset.selectedLocation || 'US'; // default to US if not found
  
    sizeInputs.forEach((input) => {
      const shouldShow = isWomenSelected ? input.dataset.sizeWomenEnable === 'true' : input.dataset.sizeMenEnable === 'true';
      
      // Update visibility of the input and its label
      input.style.display = shouldShow ? 'flex' : 'none';
      const label = input.nextElementSibling;
      if (label) {
        label.style.display = shouldShow ? 'flex' : 'none';
      }
  
      // Update the label text based on the selected gender and location
      let displaySizeValue = input.value.trim(); // default to input value
      if (isWomenSelected) {
        // Construct the attribute key for women based on location
        const attrWithLocation = `sizeWomen${selectedLocation.charAt(0).toUpperCase() + selectedLocation.slice(1).toLowerCase()}`;
        displaySizeValue = input.dataset[attrWithLocation] || input.dataset.sizeWomen || input.value;
      } else {
        // Construct the attribute key for men based on location
        const attrWithLocation = `sizeMen${selectedLocation.charAt(0).toUpperCase() + selectedLocation.slice(1).toLowerCase()}`;
        displaySizeValue = input.dataset[attrWithLocation] || input.dataset.sizeMen || input.value;
      }

      // Update the label's size value
      if (label) {
        const sizeValueElement = label.querySelector('.size_value');
        if (sizeValueElement) {
          sizeValueElement.innerText = displaySizeValue.trim();
        }
      }

      // If the size is available and not yet selected, mark it as the first available
      if (shouldShow && !firstAvailableSizeInput && !input.classList.contains('disabled')) {
        firstAvailableSizeInput = input;
      }

      // Uncheck all inputs initially
      input.checked = false;
    });
  
    // Select the smallest available size input
    if (firstAvailableSizeInput) {
      firstAvailableSizeInput.checked = true;
      // Dispatch change event to trigger variant update
      firstAvailableSizeInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  
    // Update size label with updated gender and value, using the new selectedLocation logic
    const activeSize = Array.from(sizeInputs).find(input => input.checked === true);
    const sizeLabel = document.querySelector('.variant-options__size .size-option_label');
    const sizeActiveGender = this.mainProductAttr.getAttribute('data-active-gender');
    const productType = this.mainProductAttr.getAttribute('data-product-type');
  
    let sizeLabelText;
  
    if (productType === 'Footwear') {
      const baseAttr = sizeActiveGender === 'women' ? 'sizeWomen' : (sizeActiveGender === 'men' ? 'sizeMen' : null);
      let displaySizeValue = activeSize?.value; // fallback
  
      if (baseAttr) {
        // Inline capitalization logic for location key
        const locationKey = selectedLocation.charAt(0).toUpperCase() + selectedLocation.slice(1).toLowerCase();
        const attrWithLocation = baseAttr + locationKey;
  
        // Try location-specific attribute, else fallback to base, then to input.value
        displaySizeValue = activeSize?.dataset[attrWithLocation] || activeSize?.dataset[baseAttr] || activeSize?.value;
      }
  
      if (sizeActiveGender === 'women') {
        sizeLabelText = window.genderStrings.women +` ${selectedLocation} ${displaySizeValue}`;
      } else if (sizeActiveGender === 'men') {
        sizeLabelText = window.genderStrings.men +` ${selectedLocation} ${displaySizeValue}`;
      } else {
        sizeLabelText = displaySizeValue;
      }
    } else {
      // For other product types, use the activeSize's value
      if(sizeLabel) sizeLabel.textContent = activeSize?.value;
    }

    const genderUpdatedEvent = new CustomEvent('genderUpdated', {
      detail: {
        gender: this.mainProductAttr.getAttribute('data-active-gender')
      }
    });
    document.dispatchEvent(genderUpdatedEvent);
  
    sizeLabel.textContent = sizeLabelText;
  
    // After updating sizes, update label classes
    updateLabelClasses();
  }
}

customElements.define('gender-toggle', GenderToggle);


function updateLabelClasses() {
  const labels = document.querySelectorAll('.variant-options__size .size-inputs-wrapper label');

  const itemsPerRow = 9;
  const labelsArray = Array.from(labels).filter(label => label.style.display !== 'none');
  const totalItems = labelsArray.length;
  const totalRows = Math.ceil(totalItems / itemsPerRow);

  // Remove existing classes
  labels.forEach(label => {
    label.classList.remove('first-row', 'last-row', 'first-column', 'last-column', 'uneven-rows');
  });

  labelsArray.forEach((label, index) => {
    const row = Math.floor(index / itemsPerRow);
    const column = index % itemsPerRow;

    // First row
    if (row === 0) {
      if (column === 0) {
        label.classList.add('first-row', 'first-column');
      }
      if (column === itemsPerRow - 1 || index === totalItems - 1) {
        // Last item in the first row
        label.classList.add('first-row', 'last-column');
      }
    }

    // Last row
    if (row === totalRows - 1) {
      if (column === 0) {
        label.classList.add('last-row', 'first-column');
      }
      if (index === totalItems - 1) {
        // Last item overall
        label.classList.add('last-row', 'last-column');
      }
    }
  });

  // Handle uneven rows
  const itemsInFirstRow = Math.min(itemsPerRow, totalItems);
  const itemsInSecondRow = totalItems - itemsInFirstRow;

  if (itemsInSecondRow > 0 && itemsInSecondRow < itemsPerRow) {
    // Rows have different number of items
    labelsArray[itemsInFirstRow - 1].classList.add('uneven-rows');
  }
}

updateLabelClasses();


class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.initTabs();

    if (this.dataset.url) {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then((response) => response.text())
          .then((text) => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
              this.remove();
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }

            this.initTabs();
          })
          .catch((e) => {
            console.error(e);
          });
      };

      new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
    }
  }

  initTabs() {
    const tabs = this.querySelectorAll('[role="tab"]');
    const panels = this.querySelectorAll('[role="tabpanel"]');

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        tabs.forEach((tab) => tab.setAttribute('aria-selected', false));
        panels.forEach((panel) => panel.setAttribute('aria-hidden', true));

        tab.setAttribute('aria-selected', true);
        const panelId = tab.getAttribute('aria-controls');
        document.getElementById(panelId).setAttribute('aria-hidden', false);
      });
    });
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

/* Cariuma Customizations */

function initializeSwiper(selector) {
  document.querySelectorAll(selector).forEach((element) => {
    const options = JSON.parse(element.getAttribute('data-swiper-options'));
    new Swiper(element, {
      ...options,
      slidesPerView: 'auto',
      navigation: {
        nextEl: element.querySelector('.swiper-button-next'),
        prevEl: element.querySelector('.swiper-button-prev'),
      },
      pagination: {
        el: element.querySelector('.swiper-pagination'),
        clickable: true,
      },
    });
  });
}

// Expose the initializeSwiper function to the window object
window.initializeSwiper = initializeSwiper;

document.addEventListener('DOMContentLoaded', () => {

  // Initialize Swiper sliders on DOMContentLoaded
  initializeSwiper('.swiper-container');

  // PDP - Set the selected size option to be horizontally centered for mobile devices
  if (window.innerWidth < 768) {
      const container = document.querySelector('.variant-options__size .size-inputs-wrapper');
      
      // Check if the container exists before proceeding
      if (container) {
          const checkedInput = container.querySelector('input[type="radio"]:checked');
          
          if (checkedInput) {
              const label = checkedInput.nextElementSibling;
              const labelRect = label.getBoundingClientRect();
              const containerRect = container.getBoundingClientRect();
              
              const scrollPosition = (labelRect.left + labelRect.width / 2) - (containerRect.left + containerRect.width / 2);

              container.scrollLeft += scrollPosition;
          }
      }
  }
});


document.addEventListener('DOMContentLoaded', function() {
  const backToTopButton = document.getElementById('backToTop');
  window.addEventListener('scroll', function() {
    if (window.scrollY > 700) {
      backToTopButton.classList.add('visible');
    } else {
      backToTopButton.classList.remove('visible');
    }
  });
  backToTopButton.addEventListener('click', function() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});


// This function injects custom styles specifically for the Shopify Forms App.
// It ensures the form elements maintain consistent design with the store's theme.
function waitForShadowInput({
  selector = '#app-embed',
  inputSelector = '[data-sizing="form-wrapper"] input',
  onReady,
  maxAttempts = 20,
  interval = 300,
}) {
  let attempts = 0;

  const check = () => {
    const appEmbed = document.querySelector(selector);
    const shadowRoot = appEmbed?.shadowRoot;
    const input = shadowRoot?.querySelector(inputSelector);

    if (input) {
      onReady?.(shadowRoot);
    } else if (++attempts < maxAttempts) {
      setTimeout(check, interval);
    } else {
      console.warn(`Element "${inputSelector}" not found in shadow DOM after ${maxAttempts} attempts.`);
    }
  };

  check();
}

document.addEventListener('DOMContentLoaded', function() {
  waitForShadowInput({
    onReady: (shadowRoot) => {
      const style = document.createElement('style');
      style.textContent = `
        [data-sizing="form-wrapper"] {
            max-width: 726px !important;
            margin: 0 auto;
        }
        [data-sizing="form-wrapper"] input,
        [data-sizing="form-wrapper"] label, 
        [data-sizing="form-wrapper"] button,
        [data-sizing="form-wrapper"] h2,
        [data-sizing="form-wrapper"] p {
          font-family: "HCo Gotham", sans-serif !important;
        }

        [data-sizing="form-wrapper"] input,
        [data-sizing="form-wrapper"] label {
          color: #000 !important;
        }

        [data-sizing="form-wrapper"] button {
          font-weight: 700 !important;
          font-size: 14px !important;
        }

        [data-sizing="form-wrapper"] h2,
        [data-sizing="form-wrapper"] p {
          font-weight: 500 !important;
        }
      `;
      shadowRoot.appendChild(style);
    }
  });
});


/**
 * This script waits for the Gorgias chat widget to load,
 * then injects custom styles into the chat button iframe
 * based on the screen size (responsive behavior).
 * It also listens for window resize events to dynamically
 * update styles for desktop and mobile views.
 */

var initGorgiasChatPromise = 
  (window.GorgiasChat) ? window.GorgiasChat.init() : new Promise(function (resolve) { 
    window.addEventListener('gorgias-widget-loaded', function () { 
      resolve();
    })
  });

initGorgiasChatPromise.then(function () {
  var timer = setInterval(checkGorgiasButton, 50);
  let timeout = setTimeout(() => clearInterval(timer), 5000);
  
  function checkGorgiasButton () {
    var chatButtonHead = document.querySelector('#gorgias-chat-container')
        ?.querySelector('#chat-button')
        ?.contentWindow.document.querySelector('head');

    if (!chatButtonHead || ![...chatButtonHead.children].some(x => x.getAttribute("data-emotion"))) {
        return;
    }

    clearTimeout(timeout);
    clearInterval(timer);

    const buttonStyle = document.createElement('style');
    chatButtonHead.appendChild(buttonStyle);

    const applyButtonStyles = () => {
      const isLarge = window.matchMedia('(min-width: 1024px)').matches;

        buttonStyle.textContent = isLarge
          ? `
              #gorgias-chat-messenger-button {
                  width: 50px; 
                  height: 50px;
                  border-radius: 50%;
                  padding: 0;
              }
              #gorgias-chat-messenger-button > *:first-child {
                  width: 20px;
                  height: 15px;
              }
              #gorgias-chat-messenger-button > *:nth-child(2) {
                left: 2px;
                top: 4px; 
              }
          `
          : `
              #gorgias-chat-messenger-button {
                  width: 40px; 
                  height: 40px;
                  border-radius: 50%;
                  padding: 0;
              }
              #gorgias-chat-messenger-button > *:first-child {
                  width: 15px;
                  height: 15px;
                  left: 10px;
              }
              #gorgias-chat-messenger-button > *:nth-child(2) {
                  top: 1px;
                  left: 0;
                  width: 35px;
                  height: 35px;
              }

          `;
    };

    applyButtonStyles(); // Apply initially
    window.addEventListener('resize', applyButtonStyles); // Update on resize
  }
  
});

// Gender Navigation Handler - Update cart attribute before navigating to opposite gender product
document.addEventListener('DOMContentLoaded', function() {
  // Handle gender navigation buttons (not GenderToggle buttons)
  document.addEventListener('click', function(event) {
    const genderButton = event.target.closest('.gender-link');
    
    // Only handle navigation buttons that have data-url and data-gender, and are NOT inside gender-toggle
    if (genderButton && 
        genderButton.dataset.url && 
        genderButton.dataset.gender && 
        !genderButton.disabled &&
        !genderButton.closest('gender-toggle')) {
      
      const targetGender = genderButton.dataset.gender;
      const targetUrl = genderButton.dataset.url;
      
      if (targetGender && (targetGender === 'men' || targetGender === 'women') && targetUrl) {
        // Update cart attribute first
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ 
            attributes: { 
              'active_gender': targetGender 
            } 
          })
        })
        .then(response => response.json())
        .then(data => {
          console.log('Gender updated before navigation:', targetGender);
          // Navigate to the opposite gender product URL
          window.location.href = targetUrl;
        })
        .catch((error) => {
          console.error('Error updating cart gender:', error);
          // Fallback: navigate anyway
          window.location.href = targetUrl;
        });
      }
    }
  });
});
